import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import Cookie from '../../assets/icons/Cookie.svg';
import { CustomButton } from '../custom-button';

import { ScCookieButtonsWrapper, ScCookieWrapper } from './styled';

export const CookieBanner = () => {
	const [cookieAccepted, setCookieAccepted] = useState(true);
	const theme = useTheme();

	useEffect(() => {
		const cookieAccepted = localStorage.getItem('cookieAccepted');
		if (cookieAccepted) {
			setCookieAccepted(true);
		} else {
			setCookieAccepted(false);
		}
	}, []);

	const handleAcceptCookie = () => {
		localStorage.setItem('cookieAccepted', 'true');
		setCookieAccepted(true);
	};

	const handleRejectCookie = () => {
		localStorage.setItem('cookieAccepted', 'false');
		setCookieAccepted(true);
	};

	return (
		<ScCookieWrapper isOpen={!cookieAccepted}>
			<img src={Cookie} alt={'cookie'} />
			<p>
				We use cookies on this site to enhance your experience. For a complete overview of all
				cookies used please see our <a href="/cookie-policy/">cookie policy</a>. Your privacy is
				important to us and we will never sell your data.{' '}
				<a href="/privacy-policy/">Privacy policy</a>.
			</p>
			<ScCookieButtonsWrapper>
				<CustomButton
					background={theme.colors.transparent}
					color={theme.colors.darkText}
					isArrow
					onClick={handleRejectCookie}
				>
					Reject cookies
				</CustomButton>
				<CustomButton
					hoverBackground={theme.colors.transparent}
					hoverColor={theme.colors.darkText}
					isArrow
					onClick={handleAcceptCookie}
				>
					Accept cookies
				</CustomButton>
			</ScCookieButtonsWrapper>
		</ScCookieWrapper>
	);
};
